import { render, staticRenderFns } from "./base-card-header.vue?vue&type=template&id=52ca5ff3"
import script from "./base-card-header.vue?vue&type=script&setup=true&lang=js"
export * from "./base-card-header.vue?vue&type=script&setup=true&lang=js"
import style0 from "./base-card-header.vue?vue&type=style&index=0&id=52ca5ff3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports